import type { TFunction } from "i18next"

/**
 * O nome legível do meio de pagamento, com o valor cru como rede.
 *
 * <p>O core cria meios novos antes do portal saber deles. Sem o fallback, um método que ainda não
 * tem tradução renderiza a própria chave (`common.paymentMethods.NUPAY`) no meio da ficha do
 * pedido — pior do que mostrar `NUPAY`, que ao menos é lido por quem trabalha com isso.</p>
 */
export const getPaymentMethodLabel = (
  method: string | undefined,
  t: TFunction
): string | undefined => {
  if (!method) return undefined

  return t(`common.paymentMethods.${method}`, {
    defaultValue: method,
  })
}
